import { error, misc, success } from "app/themes/colors";
import EnumDataSource from "utils/enum-data-source.util";

export const RECIPIENT_DEFAULT_TYPE = 1;

const recipientTypes = {
  [RECIPIENT_DEFAULT_TYPE]: "Recipient",
  2: "CC",
  3: "BCC",
  4: "Reply To"
};

export const RECIPIENT_TYPES = new EnumDataSource(recipientTypes);

export const RECIPIENT_PATIENT_OBJECT_TYPE = "Patient";
export const RECIPIENT_PHYSICIAN_OBJECT_TYPE = "ReferringPhysician";

const recipientObjectTypes = {
  [RECIPIENT_PATIENT_OBJECT_TYPE]: "Patients",
  [RECIPIENT_PHYSICIAN_OBJECT_TYPE]: "Physicians"
};

export const RECIPIENT_OBJECT_TYPES = new EnumDataSource(recipientObjectTypes);

export enum EmailStatus {
  "Pending" = 1,
  "Sent",
  "Delivery Delayed",
  "Delivered",
  "Opened",
  "Clicked",
  "Complained",
  "Failed",
  "Muted",
  "Bounced",
  "Received"
}

export const EMAIL_STATUS_COLORS: Record<EmailStatus, string> = {
  [EmailStatus.Pending]: misc.darkYellow,
  [EmailStatus.Sent]: misc.darkYellow,
  [EmailStatus["Delivery Delayed"]]: error[400],
  [EmailStatus.Delivered]: success[600],
  [EmailStatus.Opened]: success[600],
  [EmailStatus.Clicked]: success[600],
  [EmailStatus.Complained]: error[400],
  [EmailStatus.Failed]: error[400],
  [EmailStatus.Muted]: misc.grayAsphalt,
  [EmailStatus.Bounced]: misc.warningText,
  [EmailStatus.Received]: success[600]
};

const emailStatuses = {
  [EmailStatus.Pending]: "Pending",
  [EmailStatus.Sent]: "Sent",
  [EmailStatus["Delivery Delayed"]]: "Delivery Delayed",
  [EmailStatus.Delivered]: "Delivered",
  [EmailStatus.Opened]: "Opened",
  [EmailStatus.Clicked]: "Clicked",
  [EmailStatus.Complained]: "Complained",
  [EmailStatus.Failed]: "Failed",
  [EmailStatus.Muted]: "Muted",
  [EmailStatus.Bounced]: "Bounced",
  [EmailStatus.Received]: "Received"
};

export const EMAIL_STATUSES = new EnumDataSource(emailStatuses);
